import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useCart } from '../context/CartContext';
import { API_ENDPOINTS } from '../apiConfig';

const CheckoutPage = () => {
  const { cartItems, totalPrice, clearCart } = useCart();
  
  const [formData, setFormData] = useState({
    jmeno: '', email: '', telefon: '', adresa: '', mesto: '', psc: '', poznamka: ''
  });

  const [shipping, setShipping] = useState({ method: 'zasilkovna', price: 79 });
  const [payment, setPayment] = useState('qr');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Automatická oprava platby při změně dopravy
  useEffect(() => {
    if (shipping.method === 'zasilkovna' && payment === 'hotovost') {
      setPayment('qr');
    }
  }, [shipping.method, payment]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleShippingChange = (method, price) => {
    setShipping({ method, price });
  };

  const finalTotal = totalPrice + shipping.price;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const kompletniObjednavka = {
      zakaznik: formData,
      produkty: cartItems,
      doprava: shipping,
      platba: payment,
      celkovaCena: finalTotal
    };

    try {
      const response = await fetch(API_ENDPOINTS.ORDER, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(kompletniObjednavka),
      });

      const data = await response.json();

      if (data.status === 'success') {
        alert("Objednávka byla úspěšně odeslána!");
        clearCart();
        window.location.href = '/profil';
      } else {
        alert("Chyba: " + data.message);
      }
    } catch (error) {
      console.error("Chyba při odesílání:", error);
      alert("Nepodařilo se spojit se serverem. Zkuste to prosím znovu.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ backgroundColor: '#f4e9dc', minHeight: '100vh', paddingTop: '140px', paddingBottom: '100px', color: '#2b1f18' }}>
      <div style={{ maxWidth: '1100px', margin: 'auto', padding: '0 20px', display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: '40px' }}>
        
        {/* LEVÁ STRANA: FORMULÁŘ */}
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          style={{ background: '#fff', padding: '40px', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}
        >
          <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Doručovací údaje</h2>
          <form id="checkout-form" onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <div style={{ gridColumn: 'span 2' }}>
              <label style={labelStyle}>Celé jméno</label>
              <input type="text" name="jmeno" required style={inputStyle} onChange={handleChange} />
            </div>
            <div>
              <label style={labelStyle}>E-mail</label>
              <input type="email" name="email" required style={inputStyle} onChange={handleChange} />
            </div>
            <div>
              <label style={labelStyle}>Telefon</label>
              <input type="tel" name="telefon" required style={inputStyle} onChange={handleChange} />
            </div>
            
            {shipping.method === 'zasilkovna' && (
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} style={{ gridColumn: 'span 2', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div style={{ gridColumn: 'span 2' }}>
                  <label style={labelStyle}>Ulice a č.p.</label>
                  <input type="text" name="adresa" required style={inputStyle} onChange={handleChange} />
                </div>
                <div>
                  <label style={labelStyle}>Město</label>
                  <input type="text" name="mesto" required style={inputStyle} onChange={handleChange} />
                </div>
                <div>
                  <label style={labelStyle}>PSČ</label>
                  <input type="text" name="psc" required style={inputStyle} onChange={handleChange} />
                </div>
              </motion.div>
            )}

            <h2 style={{ gridColumn: 'span 2', marginTop: '20px', marginBottom: '10px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Doprava a platba</h2>
            
            <div style={{ gridColumn: 'span 2' }}>
              <div onClick={() => handleShippingChange('zasilkovna', 79)} style={shipping.method === 'zasilkovna' ? activeMethod : methodStyle}>
                <span>📦 Zásilkovna (na adresu)</span> <strong>79 Kč</strong>
              </div>
              <div onClick={() => handleShippingChange('osobni', 0)} style={shipping.method === 'osobni' ? activeMethod : methodStyle}>
                <span>🏠 Osobní odběr (Svatobořice)</span> <strong>Zdarma</strong>
              </div>
            </div>

            <div style={{ gridColumn: 'span 2', display: 'flex', gap: '10px' }}>
               <div onClick={() => setPayment('qr')} style={payment === 'qr' ? activePayment : paymentStyle}>🖼️ QR kód / Převod</div>
               
               {shipping.method === 'osobni' && (
                 <motion.div 
                   initial={{ scale: 0.8, opacity: 0 }} 
                   animate={{ scale: 1, opacity: 1 }} 
                   onClick={() => setPayment('hotovost')} 
                   style={payment === 'hotovost' ? activePayment : paymentStyle}
                 >
                   💵 Hotově při převzetí
                 </motion.div>
               )}
            </div>

            <div style={{ gridColumn: 'span 2', marginTop: '20px' }}>
              <label style={labelStyle}>Poznámka k objednávce</label>
              <textarea name="poznamka" rows="3" style={inputStyle} onChange={handleChange}></textarea>
            </div>
          </form>
        </motion.div>

        {/* PRAVÁ STRANA: REKAPITULACE */}
        <motion.div 
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          style={{ background: '#fff', padding: '30px', borderRadius: '20px', height: 'fit-content', position: 'sticky', top: '140px' }}
        >
          <h3 style={{ marginBottom: '20px' }}>Shrnutí objednávky</h3>
          <div style={{ maxHeight: '300px', overflowY: 'auto', marginBottom: '20px' }}>
            {cartItems.map((item, idx) => (
              <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', fontSize: '0.9rem' }}>
                <span>{item.name}</span>
                <strong>{item.price} Kč</strong>
              </div>
            ))}
          </div>
          
          <div style={{ borderTop: '1px solid #eee', paddingTop: '15px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
              <span>Zboží:</span>
              <span>{totalPrice} Kč</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
              <span>Doprava:</span>
              <span>{shipping.price} Kč</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '1.3rem', fontWeight: 'bold', color: '#8b5a2b' }}>
              <span>Celkem:</span>
              <span>{finalTotal} Kč</span>
            </div>
          </div>

          <button 
            form="checkout-form"
            type="submit" 
            disabled={isSubmitting || cartItems.length === 0}
            className="contact-button"
            style={{ 
                width: '100%', 
                marginTop: '30px', 
                cursor: (isSubmitting || cartItems.length === 0) ? 'not-allowed' : 'pointer',
                opacity: (isSubmitting || cartItems.length === 0) ? 0.6 : 1
            }}
          >
            {isSubmitting ? 'Odesílám...' : 'Odeslat objednávku'}
          </button>
        </motion.div>

      </div>
    </div>
  );
};

// --- STYLY ---
const labelStyle = { display: 'block', marginBottom: '5px', fontWeight: '600', fontSize: '0.85rem' };
const inputStyle = { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '1rem' };
const methodStyle = { display: 'flex', justifyContent: 'space-between', padding: '15px', border: '1px solid #ddd', borderRadius: '10px', marginBottom: '10px', cursor: 'pointer', transition: '0.3s' };
const activeMethod = { ...methodStyle, borderColor: '#d1b892', background: '#fdf9f4', borderLeft: '5px solid #d1b892' };
const paymentStyle = { flex: 1, textAlign: 'center', padding: '15px', border: '1px solid #ddd', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' };
const activePayment = { ...paymentStyle, borderColor: '#d1b892', background: '#fdf9f4' };

export default CheckoutPage;